import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TIPO_LABEL } from "@/lib/stages";

export function PipelineFormModal({ open, onClose, form, setForm, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-xs">
        <DialogHeader>
          <DialogTitle className="text-zinc-100 text-base font-semibold">Nova campanha</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <Label className="text-xs">Nome *</Label>
            <Input
              data-testid="pipeline-name-input"
              value={form.nome}
              onChange={(e) => setForm({ ...form, nome: e.target.value })}
              placeholder="Ex: Aniversariantes do mês"
              className="h-8 text-xs"
            />
          </div>
          <div>
            <Label className="text-xs">Tipo</Label>
            <Select value={form.tipo} onValueChange={(v) => setForm({ ...form, tipo: v })}>
              <SelectTrigger data-testid="pipeline-type-select" className="h-8 text-xs"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="novo" className="text-xs">{TIPO_LABEL.novo}</SelectItem>
                <SelectItem value="base" className="text-xs">{TIPO_LABEL.base}</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs">Valor da oferta (R$)</Label>
            <Input
              data-testid="pipeline-offer-input"
              type="number"
              value={form.offer_value}
              onChange={(e) => setForm({ ...form, offer_value: e.target.value })}
              placeholder="Ex: 199"
              className="h-8 text-xs"
            />
          </div>
          <Button data-testid="pipeline-create-btn" type="submit" className="w-full bg-amber-500 text-zinc-950 hover:bg-amber-600 h-8 text-xs font-semibold">
            Criar campanha
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
